<template>
    <b-form @submit.prevent>
        <b-row class="align-items-end">
            <b-col cols="12" :md="modal ? 12 : 3" class="mb-3 mb-md-0">
                <b-form-group
                    id="name"
                    class="row"
                    :label="$t('contact.name')"
                    label-for="name-input"
                    label-cols="12"
                    content-cols="12"
                >
                    <b-form-input id="name-input" v-model="model.name" :placeholder="$t('contact.placeholders.name')"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="12" :md="modal ? 12 : 7" class="mb-3 mb-md-0">
                <b-form-group
                    id="additional-data"
                    class="row"
                    :label="$t('contact.additional_data')"
                    label-for="additional-data-list"
                    label-cols="12"
                    content-cols="12"
                >
                    <input
                        class="form-control"
                        id="additional-data-list"
                        type="text"
                        @change="refreshAdditionalData"
                        ref="additionalDataList"
                    />
                </b-form-group>
            </b-col>
            <b-col v-if="!modal" cols="12" md="2" class="text-center text-md-start">
                <b-button class="btn-rounded px-3" variant="primary" @click="save">
                    <i class="fas fa-save me-2"></i>{{ $t('contact.save') }}</b-button>
            </b-col>
        </b-row>
    </b-form>
</template>

<script>
import {mapGetters} from "vuex";
import Choices from "choices.js";

export default {
    name: "ContactForm",

    props: {
        modal: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        ...mapGetters({
            model: 'contact/item'
        }),

        readyToInit: function () {
            return this.isMounted && this.model?.additional_data && ! this.isInit;
        },
    },

    data: function () {
        return {
            isMounted: false,
            isInit: false
        };
    },

    methods: {
        save: function () {
            const action = this.model && this.model.m_id ? 'update' : 'create';

            return this.$store.dispatch(`contact/${action}`, this.model);
        },

        refreshAdditionalData: function (event) {
            this.model.additional_data = event.target.value.split(',');
        },

        initChoice: function () {
            const options = {
                delimiter: ",",
                editItems: true,
                removeItemButton: true,
                items: this.modal ? [] : Array.isArray(this.model.additional_data) ? this.model.additional_data : JSON.parse(this.model.additional_data)
            };

            new Choices(this.$refs['additionalDataList'], options);
        },
    },

    destroyed() {
        this.$store.dispatch('contact/emptyItem');
    },

    watch: {
        readyToInit: {
            immediate: true,
            handler: function (val) {
                if (val === true) {
                    this.initChoice();
                }
            },
        }
    },

    mounted: function () {
        this.isMounted = true;

        if (this.modal) {
            this.initChoice();
        }
    },
}
</script>

<style scoped>

</style>
